var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7856 11.25H10.0356V7.44C10.0356 7.32416 10.0357 7.25336 10.0373 7.19952C10.0386 7.15463 10.0409 7.13773 10.0409 7.13773C10.0689 6.97294 10.2214 6.79492 10.4799 6.75671C10.5115 6.75203 10.5628 6.75 10.8285 6.75H13.7856C15.1962 6.75 16.2499 7.80526 16.2499 9C16.2499 10.1947 15.1962 11.25 13.7856 11.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.7839 5.24998L13.7857 5.25C15.9256 5.25 17.75 6.88104 17.75 9C17.75 11.119 15.9256 12.75 13.7857 12.75H10.0357V14.25H12.5C12.9142 14.25 13.25 14.5858 13.25 15C13.25 15.4142 12.9142 15.75 12.5 15.75H10.0357V18C10.0357 18.4142 9.69993 18.75 9.28571 18.75C8.8715 18.75 8.53571 18.4142 8.53571 18V15.75H8C7.58579 15.75 7.25 15.4142 7.25 15C7.25 14.5858 7.58579 14.25 8 14.25H8.53571V12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H8.53571L8.53568 7.39531C8.53549 7.21838 8.53531 7.04478 8.56211 6.8868C8.70842 6.02466 9.41881 5.39728 10.2606 5.27284C10.4169 5.24973 10.59 5.24985 10.7839 5.24998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.afe4b7c96a06a0d96e928dec12ecb9d9.svg";
export { ForwardRef as ReactComponent };